<!-- SIDEBAR CONTENT -->
<div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{y:'50px'}}">

    <div class="p-24">
        <button mat-raised-button
                class="mat-accent add-todo-button w-100-p"
                (click)="newProduct()"
                aria-label="New Product">
            {{'New'|translate}}
        </button>
    </div>

    <div class="nav material2">
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/pos'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">local_offer</mat-icon>
                <span>{{'POS'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/products'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">local_offer</mat-icon>
                <span>{{'Products'|translate}}</span>
            </a>
        </div>
        <div class="nav-item">
            <a class="nav-link" matRipple [routerLink]="'/cash-reports'" [routerLinkActive]="[]">
                <mat-icon class="nav-link-icon">local_offer</mat-icon>
                <span>{{'Cash reports'|translate}}</span>
            </a>
        </div>
    </div>

</div>
<!-- / SIDEBAR CONTENT -->
